module.exports = __webpack_public_path__ + "img/6.720f2c13.jpg";